import { BaseClient } from './base-client';
import { Service, CreateServiceRequest, UpdateServiceRequest, CronApiConfig } from './types';

export class ServicesClient extends BaseClient {
  constructor(config: CronApiConfig) {
    super(config);
  }

  /**
   * Get all services
   */
  public async getAll(): Promise<Service[]> {
    return this._get<Service[]>('/api/services');
  }

  /**
   * Get a service by ID
   */
  public async getById(id: string): Promise<Service> {
    return this._get<Service>(`/api/services/${id}`);
  }

  /**
   * Create a new service
   */
  public async create(service: CreateServiceRequest): Promise<Service> {
    return this._post<Service>('/api/services', service);
  }

  /**
   * Update an existing service
   */
  public async update(service: UpdateServiceRequest): Promise<Service> {
    return this._put<Service>(`/api/services/${service.id}`, service);
  }

  /**
   * Delete a service
   */
  public async delete(id: string): Promise<void> {
    return this._delete<void>(`/api/services/${id}`);
  }
}
